/* eslint-disable react/jsx-pascal-case */
import { Row, Col, Modal, Button, Form, Card } from "../../ui/ot";
import React, { useEffect, useState } from "react";
import { useComponent } from "../controller/component_controller";
import useBlogMedia from '../components/use_blog_media'; // 引入自定義 hook

const ComponentLibraryModal = ({
    axiosMode = "post",
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => { },
    onFinish = () => { },
    editcard,
    addContainer = () => { },
    developer = true
}) => {
    const axiosModelanguage = {
        post: "新增",
        patch: "修改",
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0);
    const showModal = () => {
        // setFormReloadCount((pre) => pre + 1);
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };
    const { ComponentData, getComponentData } = useComponent({
        onFinish: () => { },
        onBefore: () => { },
    });

    const {
        files,
        get_picture,
        toLinkSomewhere,
        isMoreContentEmpty,
        renderMediaContent,
    } = useBlogMedia([]); // 使用自定義 hook
    const contentStyle = {
        height: "20vh",
        width: "100%",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
    };

    const sliderSettings = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
    };
    useEffect(() => {
        getComponentData({});
    }, []);
    useEffect(() => {
        // setFormReloadCount((pre) => pre + 1);
    }, [propsOpen]);

    return (
        <>
            {propsOpen === null && (
                <Button htmlType="button" size="large" type="primary" onClick={showModal}>
                    {`新增區塊`}
                </Button>

            )}

            <Modal
                style={{ top: 10 }}
                title={`模板庫`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                contentStyle={{
                    padding: 16,
                }}
                width={1200}
                okText={"送出"}
                cancelText={"取消"}
                footer={
                    <Button
                        onClick={() => {
                            handleCancel();
                        }}
                    >
                        關閉
                    </Button>
                }
            >
                <Row
                    style={{
                        maxHeight: "80vh",
                        // overflowX: "scroll",
                        overflowY: "scroll",
                    }}
                >
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            {(ComponentData || [])
                                .filter((element) => {
                                    //不被秀出來的component
                                    return element?.frontend_component_name_client !== "最新消息" && element?.frontend_component_name_client !== "線上直播"
                                })
                                .map(
                                    (component, componentIndex) => {
                                        return (
                                            <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}

                                                onClick={(e) => {
                                                    addContainer(
                                                        component?.frontend_component_id,
                                                        component?.frontend_component_name
                                                    );
                                                }}
                                            >
                                                <Card
                                                    styles={{
                                                        padding: 10,
                                                    }}
                                                    title={
                                                        <>
                                                            【{componentIndex + 1}{" "}
                                                            {
                                                                component?.frontend_component_name_client
                                                            }
                                                            】
                                                        </>
                                                    }
                                                    hoverable={'hoverable'}
                                                >
                                                    <Row >

                                                        {developer &&
                                                            <Col span={24}>
                                                                檔案名稱：{component?.frontend_component_name}
                                                            </Col>
                                                        }
                                                        <Col span={24}>
                                                            樣式說明：{component?.frontend_component_note}
                                                        </Col>
                                                        <Col span={24}>
                                                            範例呈現：
                                                        </Col>
                                                        <Col span={24}
                                                            style={{
                                                                height: "25vh",
                                                            }}>
                                                            {
                                                                renderMediaContent("", [], sliderSettings, contentStyle)
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                        );
                                    }
                                )}
                        </Row>
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default ComponentLibraryModal;